import React from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@shadcn-in-nx/ui/checkbox";
import {
    Table,
    TableBody,
    TableHead,
    TableHeader,
    TableRow,
} from "@shadcn-in-nx/ui/table";
import WorkflowRow from "./WorkflowRow";
import WorkflowEmptyState from "./WorkflowEmptyState";

export default function WorkflowListView({
    workflows,
    selectedWorkflows,
    onSelectAll,
    onSelectWorkflow,
    onArchive,
    onCopied,
    isFavorite,
    onToggleFavorite,
    interfaceStyle,
    searchTerm,
    showArchived,
    appId,
    currentApp,
}) {
    const { t } = useTranslation();

    if (workflows.length === 0) {
        return (
            <WorkflowEmptyState
                searchTerm={searchTerm}
                showArchived={showArchived}
                appId={appId}
                currentApp={currentApp}
            />
        );
    }

    const allSelected =
        selectedWorkflows.size === workflows.length && workflows.length > 0;

    return (
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead className="w-8">
                        <Checkbox
                            checked={allSelected}
                            onCheckedChange={onSelectAll}
                        />
                    </TableHead>
                    <TableHead className="w-8" />
                    <TableHead>
                        {t("workflowIndex.table.automationOrApp")}
                    </TableHead>
                    <TableHead className="hidden sm:table-cell">
                        {t("workflowIndex.table.status")}
                    </TableHead>
                    <TableHead className="hidden md:table-cell">
                        {t("workflowIndex.table.created")}
                    </TableHead>
                    <TableHead className="hidden sm:table-cell">
                        {t("workflowIndex.table.steps")}
                    </TableHead>
                    <TableHead className="hidden lg:table-cell">
                        {t("workflowIndex.table.executions")}
                    </TableHead>
                    <TableHead className="w-1">
                        {t("workflowIndex.table.actions")}
                    </TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {workflows.map((workflow) => (
                    <WorkflowRow
                        key={workflow.id}
                        workflow={workflow}
                        selected={selectedWorkflows.has(workflow.id)}
                        onSelect={onSelectWorkflow}
                        isFavorite={isFavorite(workflow.id)}
                        onToggleFavorite={onToggleFavorite}
                        onArchive={onArchive}
                        onCopied={onCopied}
                        interfaceStyle={interfaceStyle}
                    />
                ))}
            </TableBody>
        </Table>
    );
}
